import { StreamDisableRangeElement } from 'communication/types/StreamElement';
import { StreamElementType } from 'communication/types/StreamElementType';

export interface StreamDisableRangeDataState {
    disableRange: number[];
}

export default function disableRangeReducer(
    element: StreamDisableRangeElement,
    nextDataState: StreamDisableRangeDataState
) {
    if (element._c === StreamElementType.DisableRange) {
        nextDataState.disableRange = element.r;
    }
}
